import React, { useMemo, useState } from 'react';
import { type RiskDriverItemProps } from './RiskDriverItem';
import RiskDriversList from './RiskDriversList';
import RiskDriversDrawer from './RiskDriversDrawer';
import ReportingFrameworks from '../reporting-frameworks/ReportingFrameworks';

type RiskDriversSectionProps = {
    dependencyItems: RiskDriverItemProps[];
    impactItems: RiskDriverItemProps[];
    isLoading: boolean;
};

const sortByScoreDescending = (items: RiskDriverItemProps[]): RiskDriverItemProps[] =>
    [...items].sort((a, b) => {
        if (a.score === null) return 1;
        if (b.score === null) return -1;
        return b.score - a.score;
    });

const RiskDriversSection = ({ dependencyItems, impactItems, isLoading }: RiskDriversSectionProps) => {
    const [isDepDrawerOpen, setIsDepDrawerOpen] = useState(false);
    const [isImpDrawerOpen, setIsImpDrawerOpen] = useState(false);

    const sortedDependencyItems = useMemo(() => sortByScoreDescending(dependencyItems), [dependencyItems]);
    const sortedImpactItems = useMemo(() => sortByScoreDescending(impactItems), [impactItems]);

    return (
        <div className='flex flex-col gap-3'>
            <h3 className='text-xl font-normal text-foreground'></h3>
            <div className='flex items-center justify-between'>
                <span className='text-xl text-black'>Top 5 Risk Drivers</span>
                <ReportingFrameworks slugPrefix='gnr-i_d' />
            </div>

            <div className='grid grid-cols-2 gap-4'>
                <RiskDriversList
                    title='Highest material dependencies'
                    items={sortedDependencyItems}
                    isLoading={isLoading}
                    onViewAll={() => setIsDepDrawerOpen(true)}
                />
                <RiskDriversList
                    title='Highest material impacts'
                    items={sortedImpactItems}
                    isLoading={isLoading}
                    onViewAll={() => setIsImpDrawerOpen(true)}
                />
            </div>

            <RiskDriversDrawer
                title='Material Dependencies'
                items={sortedDependencyItems}
                isOpen={isDepDrawerOpen}
                onClose={() => setIsDepDrawerOpen(false)}
            />
            <RiskDriversDrawer
                title='Material Impacts'
                items={sortedImpactItems}
                isOpen={isImpDrawerOpen}
                onClose={() => setIsImpDrawerOpen(false)}
            />
        </div>
    );
};

export default RiskDriversSection;
